
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="任意行高" fileName="auto-height.md" />
        <demo-block>
        <div><p>支持非固定行高</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table
            fixed-header
            :max-height=&quot;500&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            row-key-field-name=&quot;rowKey&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                },
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;a&quot;,
                        title: &quot;#&quot;,
                        width: 100,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                        renderBodyCell: ({ row }, h) =&gt; {
                            return &lt;span domPropsInnerHTML={row.name}&gt;&lt;/span&gt;;
                        },
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            getRandom(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
            initData() {
                let data = [];
                for (let i = 0; i &lt; 10000; i++) {
                    let value = &quot;&quot;;
                    if (i % 2 === 0) {
                        const rowCount = this.getRandom(3, 5);

                        for (let i = 0; i &lt; rowCount; i++) {
                            value += `this is the long word.&lt;br /&gt;`;
                        }
                    } else {
                        value = `name${i}`;
                    }

                    data.push({
                        rowKey: i,
                        index: i,
                        name: value,
                        hobby: `hobby${i}`,
                        address: `address${i}`,
                    });
                }

                this.tableData = data;
            },
        },
        created() {
            this.initData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"fixed-header":"","max-height":500,"virtual-scroll-option":_vm.virtualScrollOption,"columns":_vm.columns,"table-data":_vm.tableData,"row-key-field-name":"rowKey"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                },
                columns: [
                    {
                        field: "index",
                        key: "a",
                        title: "#",
                        width: 100,
                        align: "left",
                    },
                    {
                        field: "name",
                        key: "b",
                        title: "Name",
                        width: 200,
                        align: "left",
                        renderBodyCell: ({ row }, h) => {
                            return <span domPropsInnerHTML={row.name}></span>;
                        },
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            getRandom(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
            initData() {
                let data = [];
                for (let i = 0; i < 10000; i++) {
                    let value = "";
                    if (i % 2 === 0) {
                        const rowCount = this.getRandom(3, 5);

                        for (let i = 0; i < rowCount; i++) {
                            value += `this is the long word.<br />`;
                        }
                    } else {
                        value = `name${i}`;
                    }

                    data.push({
                        rowKey: i,
                        index: i,
                        name: value,
                        hobby: `hobby${i}`,
                        address: `address${i}`,
                    });
                }

                this.tableData = data;
            },
        },
        created() {
            this.initData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  